module.exports = __webpack_public_path__ + "img/medidor-afinidad.80eaeaaa.png";